const isObject = (error) => {
    return typeof error === 'object' && error !== null;
};
const hasProperty = (error, property) => {
    return property in error;
};
const hasPropertyOfType = (property, type) => {
    return typeof property === type;
};
export const hasErrorProperty = (error, property, type) => {
    return (isObject(error) &&
        hasProperty(error, property) &&
        hasPropertyOfType(error[property], type));
};
export const hasErrorProperties = (error, properties, type) => {
    return properties.every((property) => {
        return hasErrorProperty(error, property, type);
    });
};
